import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SettingsItem } from '../settingsitem';
export const withSettings = (WrappedComponent) => {
    return class extends React.PureComponent {
        render() {
            return (_jsx(SettingsItem, { label: this.props.label, isChecked: this.props.isChecked, onSwitchChange: this.props.onSwitchChange, children: WrappedComponent && this.props.editable && _jsx(WrappedComponent, { ...this.props }) }));
        }
    };
};
//# sourceMappingURL=withSettings.js.map